import React from 'react';
import { Field } from 'redux-form';
import { required, alphaName, notEmpty } from '../../../utils/validate';
import Input from '../../Forms/Input/input';
import Select from '../../Forms/Select/select';
import OptionList from '../../Forms/OptionList/optionList';
import PropTypes from "prop-types";

const suffixes = [
  {
    "value": "",
    "text": ""
  },
  {
    "value": "JR",
    "text": "JR"
  },
  {
    "value": "SR",
    "text": "SR"
  },
  {
    "value": "II",
    "text": "II"
  },
  {
    "value": "III",
    "text": "III"
  },
  {
    "value": "IV",
    "text": "IV"
  },
  {
    "value": "V",
    "text": "V"
  },
  {
    "value": "DDS",
    "text": "DDS"
  },
  {
    "value": "DDM",
    "text": "DDM"
  },
  {
    "value": "DO",
    "text": "DO"
  },
  {
    "value": "MD",
    "text": "MD"
  },
  {
    "value": "OD",
    "text": "OD"
  },
  {
    "value": "PHD",
    "text": "PHD"
  }
];

const NameFieldSet = (props) => {
  const { isReadOnly } = props;

  return (
    <fieldset className="container">
      <legend className="row">Name</legend>
      <div className="row">
        <div className="col-12 col-lg-4">
          <Field
            name="firstName"
            label="First name"
            component={Input}
            type="text"
            validate={[required, alphaName, notEmpty]}
            required={true}
            htmlAttributes={{
              maxLength: "32",
              disabled: isReadOnly
            }}
          />
        </div>
        <div className="col-12 col-lg-2">
          <Field
            name="middleInitial"
            label="M.I. (opt)"
            component={Input}
            validate={[alphaName]}
            type="text"
            htmlAttributes={{
              maxLength: "2",
              disabled: isReadOnly
            }}
          />
        </div>
        <div className="col-12 col-lg-4">
          <Field
            name="lastName"
            label="Last name"
            component={Input}
            type="text"
            validate={[required, alphaName, notEmpty]}
            required={true}
            htmlAttributes={{
              maxLength: "32",
              disabled: isReadOnly
            }}
          />
        </div>
        <div className="col-12 col-lg-2">
          <Field
            name="suffix"
            label="Suffix (opt)"
            component={Select}
            type="select"
            defaultValue=""
          >
            <OptionList createDefaultOption={false} options={suffixes} />
          </Field>
        </div>
      </div>
    </fieldset>);
};

export default NameFieldSet;

NameFieldSet.propTypes = {
  isReadOnly: PropTypes.bool.isRequired
};

